// React
import React, { FunctionComponent, useRef } from 'react'

// Types
import { InputProps } from './input.types'

// Styles
import {
  Container,
  ErrorMessageLabel,
  ErrorMessageWrapper,
  InputElement,
  InputWrapper
} from './input.styles'

// Components
import { ConditionallyRender } from 'component-library/conditionally-render'

// Assets
import negativeCheck from '../../assets/warning.svg'

export const Input: FunctionComponent<InputProps> = ({
  register,
  label,
  errorMessage,
  ...inputDefaultProps
}) => {
  const inputParentRef = useRef(null)

  return (
    <Container className="sisu-modal-input">
      <ConditionallyRender
        shouldRender={!!label}
        content={<label>{label}</label>}
      />

      <InputWrapper ref={inputParentRef}>
        <InputElement {...register} {...inputDefaultProps} />
      </InputWrapper>

      <ConditionallyRender
        shouldRender={!!errorMessage}
        content={
          <ErrorMessageWrapper>
            <img src={negativeCheck} />

            <ErrorMessageLabel>{errorMessage}</ErrorMessageLabel>
          </ErrorMessageWrapper>
        }
      />
    </Container>
  )
}
